var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 17.625H8.4375C8.54063 17.625 8.625 17.5406 8.625 17.4375V6.5625C8.625 6.45937 8.54063 6.375 8.4375 6.375H6.5625C6.45937 6.375 6.375 6.45937 6.375 6.5625V17.4375C6.375 17.5406 6.45937 17.625 6.5625 17.625ZM11.0625 11.0625H12.9375C13.0406 11.0625 13.125 10.9781 13.125 10.875V6.5625C13.125 6.45937 13.0406 6.375 12.9375 6.375H11.0625C10.9594 6.375 10.875 6.45937 10.875 6.5625V10.875C10.875 10.9781 10.9594 11.0625 11.0625 11.0625ZM15.5625 12.75H17.4375C17.5406 12.75 17.625 12.6656 17.625 12.5625V6.5625C17.625 6.45937 17.5406 6.375 17.4375 6.375H15.5625C15.4594 6.375 15.375 6.45937 15.375 6.5625V12.5625C15.375 12.6656 15.4594 12.75 15.5625 12.75ZM20.625 2.625H3.375C2.96016 2.625 2.625 2.96016 2.625 3.375V20.625C2.625 21.0398 2.96016 21.375 3.375 21.375H20.625C21.0398 21.375 21.375 21.0398 21.375 20.625V3.375C21.375 2.96016 21.0398 2.625 20.625 2.625ZM19.6875 19.6875H4.3125V4.3125H19.6875V19.6875Z",
    fill: "#1890FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectSelected);
export default __webpack_public_path__ + "static/media/project_selected.3b59be7befdd8ef4b6ad31a2ac78a54c.svg";
export { ForwardRef as ReactComponent };